import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("lovac_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function daysAgo(dateStr) {
  if (!dateStr) return null;
  const d = new Date(dateStr);
  const diff = Math.floor((Date.now() - d.getTime()) / (1000 * 60 * 60 * 24));
  return diff;
}

export function freshnessLabel(dateStr) {
  const d = daysAgo(dateStr);
  if (d === null) return "—";
  if (d <= 0) return "oggi";
  if (d === 1) return "1 giorno fa";
  return `${d} giorni fa`;
}

// Relative label for a task due date/time. urgent = within 1h or overdue.
export function taskDueInfo(due) {
  if (!due) return null;
  const d = new Date(due);
  if (isNaN(d.getTime())) return null;
  const diffMs = d.getTime() - Date.now();
  const mins = Math.round(diffMs / 60000);
  const overdue = diffMs < 0;
  const urgent = diffMs <= 60 * 60 * 1000; // <= 1 ora (incl. scaduto)
  let label;
  if (overdue) {
    label = "scaduto";
  } else if (mins < 60) {
    label = `tra ${Math.max(1, mins)} min`;
  } else if (mins < 60 * 24) {
    const h = Math.round(mins / 60);
    label = `tra ${h} ${h === 1 ? "ora" : "ore"}`;
  } else {
    const days = Math.round(mins / (60 * 24));
    if (days <= 7) label = `tra ${days} ${days === 1 ? "giorno" : "giorni"}`;
    else label = "il " + d.toLocaleDateString("it-IT");
  }
  return { label, urgent, overdue };
}

export default api;
